import React, {useState} from 'react';

import styles from './MenuItem.module.css';
import ImageWithPopUp from '../ImageWithPopUp';
import axios from 'axios';

const MenuItem = ({
  item,
  setItems,
}) => {
  const [likeClicked, setLikeClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleLikeClick = async () => {
    if (!isLoading) {
      setIsLoading(true);
      const API_V1 = process.env.NEXT_PUBLIC_API_V1;

      let url;
      if (!likeClicked) {
        url = `${API_V1}menu/items/${item.PK.replace('FOOD_ITEM#', '')}/like`;
      } else {
        // eslint-disable-next-line max-len
        url = `${API_V1}menu/items/${item.PK.replace('FOOD_ITEM#', '')}/dislike`;
      }

      try {
        await axios.post(url);
        const updatedCount = item.likedNum + (likeClicked ? -1 : 1);
        setItems((prevItems) => prevItems.map((type) => ({
          ...type,
          foodItems: type.foodItems.map((foodItem) => (
              foodItem.PK === item.PK ?
                  {...foodItem, likedNum: updatedCount} :
                  foodItem)),
        })));
        setLikeClicked(!likeClicked);
      } catch (e) {
        console.error('Error: ' + e);
      }

      setIsLoading(false);
    }
  };


  return (
    <div className={styles.app__menuitem}>
      <div className={styles.app__menuitem_upper_container}>
        <div className={styles.app__menuitem_image}>
          <ImageWithPopUp
            src={item.img}
            alt={item.itemName}
            layout="fill"
            objectFit="cover"/>
        </div>
        <div className={styles.app__menuitem_text}>
          <div className={styles.app__menuitem_title}>
            {item.itemName}
          </div>
          <div className={styles.app__menuitem_serves}>
            {item.servingNum &&
                <p>
                  Serves {item.servingNum}
                </p>}
          </div>
          {'price' in item &&
          <div className={styles.app__menuitem_price}>
            <p>
              {item.price !== 0 ?
                  '$ ' + (item.price / 100)
                      .toFixed(2) :
                  'Price depends'}
            </p>
          </div>}
          <div className={styles.app__menuitem_likes}>
            <i
              className={`icon-sc-like custom__clickable_link`}
              onClick={handleLikeClick}>
              <span className={`path1 ${styles.app__menuitem_likes_path1}`} />
              <span className={`path2 ${styles.app__menuitem_likes_path2}
              ${likeClicked ?
                  styles.app__menuitem_likes_path2_selected :
                  ''}`} />
            </i>
            {item.likedNum}
          </div>
        </div>
      </div>
      {item.description &&
          <div
            className={styles.app__menuitem_description}>
            {item.description}
          </div>}
    </div>
  );
};

export default MenuItem;
